<template>
  <div class="page-container">
    <Table
      ref="tableRef"
      :params="params"
      :request="searchData"
      tooltip-effect="light"
    >
      <!-- <template #search>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addNew"
            >{{$t('elp.filter.add')}}</el-button
          >
        </el-form-item>
      </template> -->
      <template #dashboard>
          <div class="header">
            {{$t('collect.diskCheck.statisticalOverview')}}
          </div>
          <div class="page-panel">
            <div class="page-row">
              <div class="panel-value sum">{{summary?.allCount}}</div>
              <div class="panel-title">{{ $t('collect.diskCheck.totalDevices') }}</div>
              <div class="panel-footer"></div>
            </div>
            <div class="page-row">
              <div class="panel-value health">{{summary?.healthyCount}}</div>
              <div class="panel-title">{{ $t('collect.diskCheck.healthyDevices') }}</div>
              <div class="panel-footer">{{ $t('collect.diskCheck.deviceRunningNormal') }}</div>
            </div>
            <div class="page-row">
              <div class="panel-value warning">{{summary?.warnCount}}</div>
              <div class="panel-title">{{ $t('collect.diskCheck.warningDevices') }}</div>
              <div class="panel-footer">{{ $t('collect.diskCheck.needAttentionBackupData') }}</div>
            </div>
            <!-- <div class="page-row">
              <div class="panel-value danger">75.38%</div>
              <div class="panel-title">危险设备</div>
              <div class="panel-footer"></div>
            </div> -->
            <div class="page-row">
              <div class="panel-value unknown">{{summary?.unknownCount}}</div>
              <div class="panel-title">{{ $t('collect.diskCheck.unknownStatus') }}</div>
              <div class="panel-footer">{{ $t('collect.diskCheck.cannotDetectCheckConnection') }}</div>
            </div>
          </div>
      </template>
      <el-table-column :width="curLang == 'zh-CN' ? '50px' : '120px'" :label="$t('activity.list.serialNo')">
        <template #default="scope">{{scope.$index + 1}}</template>
      </el-table-column>
      <el-table-column prop="robotSn" :label="$t('activity.packetjoin.robotCode')" />
      <el-table-column prop="robotName" :label="$t('status.largescreenm.robotName')" />
      <el-table-column prop="cabinetSn" :label="$t('equipment.cabinet.ctrlCode')">
        <template #default="scope">
          <span v-if="scope.row.cabinetSn?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetSn)">{{scope.row.cabinetSn}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetSn}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="diskState" :label="$t('collect.diskCheck.healthStatus')">
        <template #default="scope">
          <el-tag :type="getStatusType(scope.row.diskState)" size="small">
            <i :class="getStatusIcon(scope.row.diskState)"></i>
            {{ getStatusText(scope.row.diskState) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="diskTestResult" :label="$t('collect.diskCheck.testResults')" />
      <el-table-column prop="diskSectorCount" :label="$t('collect.diskCheck.reallocatedSectorsCount')" />
      <el-table-column prop="diskPowerOnHours" :label="$t('collect.diskCheck.powerOnHours')">
        <template #default="{ row }">
          <span>{{ `${(row && row.diskPowerOnHours) || ''} ${row.diskPowerOnHours ? $t('collect.diskCheck.hours') : ''}` }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="diskPowerOnTime" :label="$t('collect.diskCheck.powerOnCount')" />
      <el-table-column prop="diskTemperature" :label="$t('collect.diskCheck.temperature')">
        <template #default="{ row }">
          <span>{{ `${(row && row.diskTemperature) || ''}${row.diskTemperature ? '℃': ''}`}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('collect.healthscorelist.updateTime')" />
      <el-table-column prop="diskQueryTime" :label="$t('collect.diskCheck.queryTime')" />
      <el-table-column :label="$t('activity.list.operation')" width="80" fixed="right">
        <template #default="{ row }">
          <el-button
            v-show="authList.includes('diskState:detail')"
            @click="jumpReport(row)"
            type="text"
            size="small"
            >{{$t('activity.packetjoin.details')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
  </div>
</template>

<script>
import { common } from '../../common/mixin'
// import Table from '@/components/table/index'
import Table from '@/components/elp/table'
import dayjs from 'dayjs'
import { reactive, toRefs } from '@vue/reactivity'

import { reqRobotDiskHealthList } from '@/api/upgrade'
import { useRouter } from 'vue-router'
import { standard } from '@/common/constant';
import { useI18n } from 'vue-i18n'
import { computed } from "vue";
import { useStore } from "vuex"
export default {
  components: {
    Table,
  },
  mixins: [common],
  setup () {
    const store = useStore()
    const { t } = useI18n()
    const router = useRouter()
    const userInfo = window.localStorage.getItem('userInfo')
    const taskFields = [
      {
        label: t('collect.diskCheck.health'),
        value: "HEALTHY"
      },
      {
        label: t('error.alarm.warning'),
        value: "WARNING"
      },
      {
        label: t('collect.diskCheck.unknown'),
        value: "UNKNOWN"
      },
    ]
    const state = reactive({
      tableRef: null,
      query: {
        allowableTimeRange: [
          dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
          dayjs().format('YYYY-MM-DD') + ' 23:59:59'
        ]
      },
      page: 1,
      size: 10,
      total: 0,
      params: [
        {
          key: 'robotSn',
          value: '',
          label: t('activity.packetjoin.robotCode')
        },
        {
          key: 'cabinetSn',
          value: '',
          label: t('collect.healthscorelist.ctrlCabCode')
        },
        {
          type: 'Select',
          key: 'diskState',
          value: null,
          label: t('collect.diskCheck.healthStatus'),
          options: {
            data: taskFields,
            label: 'label',
            value: 'value'
          }
        },
        {
          type: 'Date',
          key: 'allowableTimeRange',
          value: [
            dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          ],
          label: t('collect.diskCheck.queryTime'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': t('activity.detail.to'),
            'start-placeholder': t('activity.list.startDate'),
            'end-placeholder': t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        }
      ],
      standard: standard,
      userInfo: userInfo ? JSON.parse(userInfo) : {},
      curLang: computed(() => store.state.lang),
      taskField: taskFields,
      ifDetial: false,
      summary: {},
      authList: JSON.parse(window.localStorage.getItem('authList'))
    })
    const searchData = async params => {
      console.log('params',params)
      params.startTime = params.allowableTimeRange?.[0]
      params.endTime = params.allowableTimeRange?.[1]
      const taskList = reqRobotDiskHealthList(params).then(res => {
        res.pageResult.total = parseInt(res.pageResult.total)
        res.pageResult.size = parseInt(res.pageResult.size)
        res.pageResult.current = parseInt(res.pageResult.current)
        state.summary = res.summary
        return res.pageResult
      })
      return taskList
    }

    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      state.tableRef?.update()
    }

    // 跳转磁盘检测详情
    const jumpReport = (row) => {
      router.push(`/collect/diskDetectionDetail?robotId=${row.robotId}`)
    }

    const handleSizeChange = val => {
      state.size = val
      searchData()
    }

    const handleCurrentChange = val => {
      state.page = val
      searchData()
    }
    const getStatusType = (status) => {
      const typeMap = {
        HEALTHY: 'success',
        WARNING: 'warning',
        DANGER: 'danger',
        UNKNOWN: 'info'
      }
      return typeMap[status] || 'info'
    }
    const  getStatusText = (status) => {
      const textMap = {
        HEALTHY: t('collect.diskCheck.health'),
        WARNING: t('error.alarm.warning'),
        DANGER:  t('collect.diskCheck.danger'),
        UNKNOWN: t('collect.diskCheck.unknown')
      }
      return textMap[status] || t('collect.diskCheck.unknown')
    }
    const  getStatusIcon = (status) => {
      const textMap = {
        HEALTHY: 'el-icon-success',
        WARNING: 'el-icon-warning',
        DANGER: 'el-icon-error',
        UNKNOWN: 'el-icon-question'
      }
      return textMap[status] || 'el-icon-question'
    }
    return {
      ...toRefs(state),
      handleSizeChange,
      handleCurrentChange,
      searchData,
      updatePage,
      jumpReport,
      getStatusType,
      getStatusText,
      getStatusIcon
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.header {
  color: #303133;
  font-size: 20px;
  font-weight: 500;
}
.page-panel {
  position: relative;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  // flex-direction: row;
  border-color: #fff;
  border-radius: 5px;
  background-color: #fff;
  z-index: 10;
  margin-top: 12px;
}
.page-panel .page-row {
  border-radius: 5px;
  color: #fff;
  text-align: left;
}
.page-panel .page-row:nth-child(1) {
  background: rgb(200 247 239);
}
.page-panel .page-row:nth-child(2) {
  background: rgba(234 250 241);
}
.page-panel .page-row:nth-child(3) {
  background:  rgba(254 245 241);
}
.page-panel .page-row:nth-child(4) {
  background: rgba(244 246 246);
}
.page-panel .page-row:nth-child(5) {
  background: #DC4B99;
}

.panel-title {
  font-size: 18px;
  color: #606266;
  text-align: center;
  margin-bottom: 8px;
  font-weight: 600;
}
.panel-value {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 12px;
}
.panel-value.sum {
  color: #32e3c5;
}
.panel-value.health {
  color: #67c23a;
}
.panel-value.warning {
  color: #e6a23c;
}
.panel-value.danger {
  color: #f56c6c;
}
.panel-value.unknown {
  color: #909399;
}
.panel-footer {
  text-align: center;
  font-size: 12px;
  color: #909399;
}

.page-row {
  position: relative;
  box-sizing: border-box;
  margin: 10px 0px;
  padding: 12px;
  border-color: #fff;
  border-radius: 5px;
  background-color: #fff;
  z-index: 99;
  /* height: 100%; */
  flex: 1;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.el-icon-delete {
  cursor: pointer;
}
:v-deep(.el-progress-circle_track) {
  color: aquamarine;
}
</style>
